export const getTrackingQuestions = async db => {
  const trackingQuestions = await db.getAll('trackingQuestions');
  return trackingQuestions.sort((a, b) => a.createdAt - b.createdAt);
};

export const isAnswerValid = (answer = {}) => {
  if (Array.isArray(answer.value)) {
    return !!answer.value.filter(Boolean).length;
  }

  return answer.value !== null && answer.value !== undefined;
};

export const getPresetQuestions = () => {
  return {
    sleep: [
      {
        id: '',
        groupId: '',
        title: 'How did you sleep?',
        priority: 0,
        type: 'number',
        createdAt: Date.now(),
        expiryDate: null,
        notes: true,
        status: 'live',
        settings: { type: 'star', calculation: 'average', default: null },
      },
      {
        id: '',
        groupId: '',
        title: 'How many hours did you sleep for?',
        priority: 0,
        type: 'number',
        createdAt: Date.now(),
        expiryDate: null,
        notes: false,
        status: 'live',
        settings: { type: 'number', calculation: 'average', default: null },
      },
    ],
    medicine: [
      {
        id: '',
        groupId: '',
        title: 'Have you taken your antibiotics?',
        priority: 0,
        type: 'options',
        createdAt: Date.now(),
        expiryDate: null,
        notes: true,
        status: 'live',
        settings: {
          type: 'checkbox',
          calculation: '',
          default: [],
          options: ['9am', '1pm', '5pm'],
        },
      },
    ],
    panic: [
      {
        id: '',
        groupId: '',
        title: 'Did you have a panic attack today?',
        priority: 0,
        type: 'options',
        createdAt: Date.now(),
        expiryDate: null,
        notes: 'What happened?',
        status: 'live',
        settings: { type: 'lightswitch', calculation: 'count', default: [] },
      },
    ],
    musical: [
      {
        id: '',
        groupId: '',
        title: 'How long did you practice your guitar for? (mins)',
        priority: 0,
        type: 'number',
        createdAt: Date.now(),
        expiryDate: null,
        notes: 'What did you work on?',
        status: 'live',
        settings: { type: 'number', calculation: 'total', default: [] },
      },
    ],
    running: [
      {
        id: '',
        groupId: '',
        title: 'How far did you run today? (km)',
        priority: 0,
        type: 'number',
        createdAt: Date.now(),
        expiryDate: null,
        notes: false,
        status: 'live',
        settings: { type: 'number', calculation: 'total', default: null },
      },
      {
        id: '',
        groupId: '',
        title: 'How long did you run for? (mins)',
        priority: 0,
        type: 'number',
        createdAt: Date.now(),
        expiryDate: null,
        notes: true,
        status: 'live',
        settings: { type: 'number', calculation: 'total', default: null },
      },
    ],
    asthma: [
      {
        id: '',
        groupId: '',
        title: 'How many inhaler puffs did you require?',
        priority: 0,
        type: 'number',
        createdAt: Date.now(),
        expiryDate: null,
        notes: false,
        status: 'live',
        settings: { type: 'plus', calculation: 'average', default: null },
      },
      {
        id: '',
        groupId: '',
        title: 'Did you have an asthma attack today?',
        priority: 0,
        type: 'options',
        createdAt: Date.now(),
        expiryDate: null,
        notes: 'What happened?',
        status: 'live',
        settings: { type: 'lightswitch', calculation: 'count', default: [] },
      },
    ],
    mood: [
      {
        id: '',
        groupId: '',
        title: 'Rate your mood today',
        priority: 0,
        type: 'number',
        createdAt: Date.now(),
        expiryDate: null,
        notes: true,
        status: 'live',
        settings: {
          type: 'range',
          min: 1,
          max: 10,
          calculation: 'average',
          default: null,
        },
      },
    ],
    discomfort: [
      {
        id: '',
        groupId: '',
        title: 'Rate your level of pain/discomfort today',
        priority: 0,
        type: 'number',
        createdAt: Date.now(),
        expiryDate: null,
        notes: true,
        status: 'live',
        settings: {
          type: 'range',
          min: 1,
          max: 10,
          calculation: 'average',
          default: null,
        },
      },
    ],
    workout: [
      {
        id: '',
        groupId: '',
        title: 'How long did you work out for? (mins)',
        priority: 0,
        type: 'number',
        createdAt: Date.now(),
        expiryDate: null,
        notes: false,
        status: 'live',
        settings: { type: 'number', calculation: 'average', default: null },
      },
      {
        id: '',
        groupId: '',
        title: 'What did you work on?',
        priority: 0,
        type: 'options',
        createdAt: Date.now(),
        expiryDate: null,
        notes: true,
        status: 'live',
        settings: {
          type: 'select',
          calculation: '',
          default: [],
          options: ['Endurance', 'Strength', 'Balance', 'Flexibility'],
        },
      },
    ],
    number: [
      {
        id: '',
        groupId: '',
        title: 'Custom question',
        priority: 0,
        type: 'number',
        createdAt: Date.now(),
        expiryDate: null,
        notes: true,
        status: 'live',
        settings: { type: 'number', calculation: 'total', default: [] },
      },
    ],
    choices: [
      {
        id: '',
        groupId: '',
        title: 'Custom question',
        priority: 0,
        type: 'options',
        createdAt: Date.now(),
        expiryDate: null,
        notes: true,
        status: 'live',
        settings: {
          type: 'select',
          calculation: '',
          default: [],
          options: ['Custom option'],
        },
      },
    ],
    tickbox: [
      {
        id: '',
        groupId: '',
        title: 'Custom question',
        priority: 0,
        type: 'options',
        createdAt: Date.now(),
        expiryDate: null,
        notes: true,
        status: 'live',
        settings: { type: 'lightswitch', calculation: 'count', default: [] },
      },
    ],
  };
};



// WEBPACK FOOTER //
// ./utils/questions.js